import { PauseCancelReasonDto } from "@intelligems/ig-types";

export const CancelItems: PauseCancelReasonDto[] = [
  {
    value: "noValueOrRoi",
    text: "Didn't see enough value or ROI",
    items: [
      {
        value: "reducingSoftwareSpend",
        text: "Reducing overall software spend",
      },
      {
        value: "pricingModelDoesntFit",
        text: "Pricing model based on order volume doesn't fit our business",
      },
      {
        value: "tooExpensiveForValue",
        text: "Too expensive for the value received",
      },
      {
        value: "switchingPlatforms",
        text: "Switching platforms/tools",
      },
      {
        value: "otherValueRoi",
        text: "Other",
      },
    ],
  },
  {
    value: "productCapabilitiesIssues",
    text: "Product capabilities or technical challenges",
    items: [
      {
        value: "missingKeyFeatures",
        text: "Missing key features we need",
      },
      {
        value: "notCompatible",
        text: "Not compatable with our site or tech stack",
      },
      {
        value: "performanceIssues",
        text: "Caused performance issues",
      },
      {
        value: "tooComplexDifficult",
        text: "Too complex or difficult to use",
      },
      {
        value: "otherProduct",
        text: "Other",
      },
    ],
  },
  {
    value: "notUsingIntelligems",
    text: "Not using Intelligems",
    items: [
      {
        value: "didntUseEnough",
        text: "Didn't use enough to justify cost",
      },
      {
        value: "insufficientOnboarding",
        text: "Onboarding wasn't sufficient for our team",
      },
      {
        value: "shortTermUseCase",
        text: "Only needed for a specific use case or short-term testing",
      },
      {
        value: "lowVolumeResults",
        text: "Store volume too low to get clear results",
      },
      {
        value: "stakeholderChanged",
        text: "Key stakeholder left or team ownership changed",
      },
      {
        value: "otherNotUsing",
        text: "Other",
      },
    ],
  },
  {
    value: "businessExternalReasons",
    text: "Business or external reasons",
    items: [
      {
        value: "businessPerformanceChallenges",
        text: "Business performance challenges",
      },
      {
        value: "brandSoldClosed",
        text: "Brand being sold or closed",
      },
      {
        value: "endingAgencyContract",
        text: "Brand ending agency contract",
      },
      {
        value: "externalFactors",
        text: "External factors (e.g. tariffs, regulations)",
      },
      {
        value: "otherBusiness",
        text: "Other",
      },
    ],
  },
];
